import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import { deDE, enUS } from "@mui/x-data-grid-pro/locales";
import { useTranslation } from "react-i18next";

type Props = Omit<DataGridProProps, "localeText">;

/** A {@link DataGridPro} with translated strings. */
export function I18nGrid(props: Props) {
  const { i18n } = useTranslation();
  return <DataGridPro localeText={getLocalization(i18n.language)} {...props} />;
}

function getLocalization(lang: string) {
  if (lang.includes("en")) return getLocaleText(enUS);

  return getLocaleText(deDE);
}

function getLocaleText(localization: unknown) {
   
  // @ts-ignore
  return localization.components?.MuiDataGrid.defaultProps?.localeText;
}
